import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CancellationNavigationEnum } from 'v3/data/store/cancellationNavigation/enum';
import { initialCancellationNavigationState } from 'v3/data/store/cancellationNavigation/state';

export const cancellationNavigationSlice = createSlice({
  name: 'cancellationNavigation',
  initialState: initialCancellationNavigationState,
  reducers: {
    setCancellationStep: (state, action: PayloadAction<CancellationNavigationEnum | null>) => {
      state.currentCancelationState = action.payload;
      return state;
    },
    setDialogState: (state, action: PayloadAction<boolean>) => {
      state.isCancellationDialogOpen = action.payload;
      return state;
    },
    setErrorDialogState: (state, action: PayloadAction<boolean>) => {
      state.isCancellationErrorDialogOpen = action.payload;
      return state;
    },
    setClearCancellationState: (state) => {
      state = initialCancellationNavigationState;
      return state;
    },
    setRefundConflictDialogState: (state, action: PayloadAction<boolean>) => {
      state.isRefundConflictDialogOpen = action.payload;
      return state;
    },
  },
});
